import TEFileManagerRow from './TEFileManagerRow'

export default TEFileManagerRow
